(() => {
  if (window.workshopStoryVideoInitialized) return;
  window.workshopStoryVideoInitialized = true;

  const selector = '.ws-media__asset--video';
  let observer;

  const playVideo = (video) => {
    if (!video || document.hidden) return;

    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    const playRequest = video.play();
    if (playRequest) playRequest.catch(() => {});
  };

  const getObserver = () => {
    if (observer || !('IntersectionObserver' in window)) return observer;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) playVideo(entry.target);
        });
      },
      { rootMargin: '200px 0px' }
    );

    return observer;
  };

  const initializeVideo = (video) => {
    if (video.dataset.workshopStoryInitialized === 'true') {
      playVideo(video);
      return;
    }

    video.dataset.workshopStoryInitialized = 'true';
    video.addEventListener('loadedmetadata', () => playVideo(video));
    video.addEventListener('canplay', () => playVideo(video));
    getObserver()?.observe(video);
    playVideo(video);
  };

  const initializeVideos = (root = document) => {
    if (root.matches?.(selector)) initializeVideo(root);
    root.querySelectorAll?.(selector).forEach(initializeVideo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeVideos(), { once: true });
  } else {
    initializeVideos();
  }

  window.addEventListener('pageshow', () => initializeVideos());
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) initializeVideos();
  });
  document.addEventListener('shopify:section:load', (event) => initializeVideos(event.target));
})();
